import React, { useState, useEffect } from "react";
import clsx from "clsx";
import PropTypes from 'prop-types';
import {
  Card,
  Typography,
  makeStyles,
  CardHeader,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';

import { SIREN_COLOR, SIREN_BOARD_ITEM_HEIGHT, SIREN_BOARD_TITLE_HEIGHT } from "config.js";
import firebase from '../../Firebase';
import 'firebase/database';
import {useSelector} from 'react-redux';
import { useIntl } from "react-intl";





/**
 * 주의
 *  - 낙상 감지: fall_confirmed
 * @param {*} param0 
 * @returns 
 */

function CautionBoard( {className, ...rest}) {

  const classes = useStyles();
  const {formatMessage} = useIntl();

  const [cautionTarget, setCautionTarget] = useState();
  const [cautionClear, setCautionClear] = useState();

  const firebaseRootRef = useSelector((store) => store.envSettings.firebaseRootRef)

  const datas = [
    {
      label: formatMessage({id:'caution_target'}),
      value: cautionTarget,
    },
    {
      label: formatMessage({id:'caution_clear'}),
      value: cautionClear,
    },

  ];


  useEffect(() => {
    if (firebaseRootRef == null || firebaseRootRef.length == 0) return;

    var dbRef = firebase.database().ref('/dashboard/'+ firebaseRootRef ).child("dashboard").child("caution");

    dbRef.on('value', function(snapshot) {
      snapshot.forEach(function(childSnapshot){

        var childKey = childSnapshot.key;
        var childData = childSnapshot.val();

        if(childKey === "target"){
          setCautionTarget(childData);
        }
        else if (childKey === "clear"){
          setCautionClear(childData);
        }
      });
    });
  }, []);


  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
      >

      <CardHeader
        className={classes.title}
        title={formatMessage({id:'caution_board_title'})}
        titleTypographyProps={{ color: 'inherit',  variant:'h6'}}
      />


      <List>
        {datas.map((data) => (
          <ListItem classes={{ divider: classes.itemDivider}}
            divider
            key={data.label}>

            <ListItemText primary={data.label}
              primaryTypographyProps={{ color: 'textSecondary', variant: 'body1' }}/>
            <Typography color="inherit" variant="h5">{data.value}</Typography>
          </ListItem>
        ))}
      </List>

    </Card>
  );
}


CautionBoard.propTypes = {
  className: PropTypes.string
};

export default CautionBoard;


const useStyles = makeStyles((theme) => ({

  root:{
  },
  title: {
    color: theme.palette.primary.contrastText,
    backgroundColor: SIREN_COLOR.CAUTION_BG2_COLOR,
    height:SIREN_BOARD_TITLE_HEIGHT,
    padding: '8px 14px',
  },
  label: {
    marginLeft: theme.spacing(1),
  },
  labelbox: {
    margin: theme.spacing(2),
  },
  current: {
    marginTop: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    // color: theme.palette.secondary.contrastText,
    // backgroundColor: theme.palette.secondary.main,
  },
  itemDivider: {
    height:SIREN_BOARD_ITEM_HEIGHT
  }
}));